import {Component, OnInit} from '@angular/core';
import {AppComponent} from 'src/app/app.component';
import {environment} from 'src/environments/environment';
import {AppMainComponent} from './app.main.component';
import {UserService} from "../../services/user.service";
import {DegradedModeService} from "../../services/degraded-mod-service";
import {ThemeService} from "../../services/theme.service";
@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styles: [`
    .layout-topbar-logo img {
      height: 45px;
    }
  `]
})
export class AppTopBarComponent implements OnInit {
  env: string = environment.env;
  showDegradedModal: boolean = false;
  darkMode: boolean = false;

  constructor(
    public degradedModeService: DegradedModeService,
    public app: AppComponent,
    public appMain: AppMainComponent,
    public userService: UserService,
    private themeService: ThemeService,
  ) {
  }

  onDarkModeChange(event: any) {
    this.themeService.setDarkMode(event.checked);
  }

  ngOnInit() {
    this.degradedModeService.init();

    this.degradedModeService.isDegradedMode().subscribe(isDegraded => {
      this.showDegradedModal = isDegraded;
    });

    this.themeService.darkMode$.subscribe(isDark => {
      this.darkMode = isDark;
    });
  }
}
